import backend from 'utils/backend'

export const SET_SAVED_SEARCHES = 'SET_SAVED_SEARCHES'

export const getSavedSearches = ({ type = 'funder', limit, offset } = {}) => async dispatch => {
  try {
    const { data } = await backend.get(`api/organizationsavedsearches/?type=${type}`, {
      params: { limit, offset }
    })
    if (data) {
      dispatch({ type: SET_SAVED_SEARCHES, payload: { results: { [type]: data } } })
    }
  } catch (err) {
    console.log({ err })
  }
}

export const addSavedSearch = ({ type = 'funder', name, search_url } = {}) => async dispatch => {
  try {
    await backend.post('api/organizationsavedsearches/', {
      type, name, search_url
    })
  } catch (err) {
    console.log({ err })
  }
}

export const deleteSavedSearch = id => async dispatch => {
  try {
    await backend.delete(`api/organizationsavedsearches/${id}/`)
  } catch (err) {
    console.log({ err })
  }
}
